import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import styled from 'styled-components';
import { CounterLabel, themeGet } from '@primer/react';

/**
 * Label for displaying counts.
 * @param {string} count
 * @param {string} scheme Color scheme to use while rendering the counts.
 */
var LTCounterLabel = function LTCounterLabel(_a) {
  var _b = _a.count,
    count = _b === void 0 ? "" : _b,
    _c = _a.scheme,
    scheme = _c === void 0 ? LTCounterLabel.Scheme.SECONDARY : _c,
    _d = _a.addDefaultMargin,
    addDefaultMargin = _d === void 0 ? true : _d;
  var StyledCounterLabel = styled(CounterLabel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), addDefaultMargin ? themeGet("space.2") : "0");
  var getCounterStyle = function getCounterStyle(scheme) {
    switch (scheme) {
      case LTCounterLabel.Scheme.PRIMARY:
        return {
          color: "fg.onEmphasis",
          backgroundColor: "bg.neutralEmphasis"
        };
      case LTCounterLabel.Scheme.SECONDARY:
        return {
          color: "fg.default",
          backgroundColor: "bg.neutralMuted"
        };
      case LTCounterLabel.Scheme.OUTLINED:
        return {
          color: "#666",
          border: "1px solid #ddd",
          backgroundColor: "#fff"
        };
      default:
        return {
          color: "text.default"
        };
    }
  };
  return /*#__PURE__*/React.createElement(StyledCounterLabel, {
    sx: getCounterStyle(scheme),
    scheme: scheme
  }, count);
};
LTCounterLabel.Scheme = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  OUTLINED: "outlined"
};
var templateObject_1;

export { LTCounterLabel as default };
